import { ArrowRight } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IMAGES, CONTACT, NAV } from "../../content/site";
import { MaskLines, ParallaxImage, Reveal } from "./motion";
import { Logo } from "./Logo";
import { scrollToId } from "./useLenis";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="relative overflow-hidden bg-[#0D2F18]">
    <ParallaxImage src={IMAGES.hecke} alt="" className="absolute inset-0 opacity-35" strength={80} />
    <div className="relative mx-auto max-w-7xl px-5 py-28 sm:px-8 md:py-44">
      <h2 className="font-display text-5xl font-medium leading-[0.98] tracking-[-0.02em] text-[#FBF9F4] sm:text-6xl lg:text-8xl">
        <MaskLines inView lines={["Lust auf einen", <em key="e" className="italic text-[#DCEFBE]">gepflegten Garten?</em>]} />
      </h2>
      <Reveal delay={0.2} className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center">
        <button data-testid="final-cta-button" onClick={() => scrollToId("kontakt")} className="btn-light group">
          Unverbindlich anfragen
          <span className="grid h-8 w-8 place-items-center rounded-full bg-[#1E5631] text-[#FBF9F4] transition-transform duration-300 group-hover:rotate-[-45deg]"><ArrowRight className="h-4 w-4" /></span>
        </button>
        <p className="max-w-sm text-[#FBF9F4]/85">Schreiben Sie uns einfach – wir freuen uns auf Ihre Nachricht.</p>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const go = (id) => (pathname === "/" ? scrollToId(id) : navigate(`/#${id}`));
  return (
  <footer data-testid="site-footer" className="bg-[#0A2412] pb-28 pt-16 text-[#FBF9F4] sm:pb-12">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-5 sm:px-8 md:flex-row md:items-start md:justify-between">
      <div>
        <Logo light />
        <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="link-underline mt-5 inline-block text-[#FBF9F4]/85">{CONTACT.email}</a>
      </div>
      <nav className="grid grid-cols-2 gap-x-10 gap-y-3 text-sm">
        {NAV.map((n) => (
          <button key={n.id} data-testid={`footer-link-${n.id}`} onClick={() => go(n.id)} className="link-underline text-left text-[#FBF9F4]/85">{n.label}</button>
        ))}
      </nav>
    </div>
    <div className="mx-auto mt-12 flex max-w-7xl flex-wrap justify-between gap-4 border-t border-[#FBF9F4]/15 px-5 pt-6 text-xs text-[#FBF9F4]/70 sm:px-8">
      <span>© 2026 GRÜNWIRBEL</span>
      <span className="flex gap-6">
        <Link to="/impressum" data-testid="footer-impressum" className="link-underline">Impressum</Link>
        <Link to="/datenschutz" data-testid="footer-datenschutz" className="link-underline">Datenschutz</Link>
      </span>
    </div>
  </footer>
  );
};
